import Vue from 'vue'
import VueI18n from 'vue-i18n'
import App from './App.vue'
import store from './store'

require("./assets/main.scss")

Vue.config.productionTip = false
Vue.use(VueI18n)

const messages = {
  en: {
    app: {
      overview: 'Overview',
      calculate:'Calculate',
      profile: 'Profile',
      graph: 'Graph',
      news: 'News',
      swap: 'Swap',
      profit: 'Profit',
      balance_sheet_detail: 'Balance Sheet Detail',
      balance_sheet_ratio: 'Balance Sheet Ratio',
      last_update: 'Last Updated',
      latest_price: 'Latest Price',
      opening: 'Opening',
      high: 'High',
      low: 'Low',
      volume: 'Volume',
      average: 'Average',
      annual_change: 'Annual Change',
      market_cap: 'Market Capital',
      balance_sheet_period: 'Balance Sheet Period',
      capital: 'Capital',
      equity: 'Equity',
      book_value: 'Book Value',
      periods: 'Periods',
      row: 'Row',
      definition: 'Period',
      percent: 'Percent',
      dif: 'Difference',
      agenda: 'Agenda',
      datetime: 'Date/Time',
      country: 'Country',
      importance: 'Importance',
      period: 'Period',
      data: 'Data',
      expectation: 'Expectation',
      before: 'Before',
      title: 'Title',
      more: 'More',
      close: 'Close',
      KurulusTarihi: 'Year of Foundation',
      SirketAdi: 'Company Name',
      Sektor: 'Sector',
      GenelMudur: 'General Manager',
      CalisanSayisi: 'Number of Employees',
      listeholders: 'Partners',
      listeholdings: 'Associates',
      YetkiliAd: 'Investor Relations Manager',
      YetkiliMail: 'Email',
      Piyasa: 'Market',
      Telefon: 'Phone',
      Faks: 'Fax',
      Adres: 'Address',
      rights_issue: 'Rights Issue',
      gratis: 'Gratis',
      dividend: 'Dividend',
      ratio: 'Ratio',
      piece: 'Piece',
      KurumAdi: 'Brokerage House',
    }
  },
  tr: {
    app: {
      overview: 'Genel',
      calculate:'Hesaplama',
      profile: 'Profil',
      graph: 'Grafik',
      news: 'Haberler',
      swap: 'Takas',
      profit: 'Getiri',
      balance_sheet_detail: 'Bilanço Detay',
      balance_sheet_ratio: 'Finansal Oranlar',
      last_update: 'Son Güncellenme Tarih',
      latest_price: 'Son Fiyat',
      opening: 'Açılış',
      high: 'Yüksek',
      low: 'Düşük',
      volume: 'Hacim',
      average: 'Ortalama',
      annual_change: 'Yıllık Değişim',
      market_cap: 'Piyasa Değeri',
      balance_sheet_period: 'Bilanço Dönemi',
      capital: 'Sermaye',
      equity: 'Özsermaye',
      book_value: 'Defter Değeri',
      periods: 'Periyotlar',
      row: 'Sıra',
      definition: 'Periyot',
      percent: 'Yüzde',
      dif: 'Fark',
      agenda: 'Gündem',
      datetime: 'Tarih/Saat',
      country: 'Ülke',
      importance: 'Önem',
      period: 'Dönem',
      data: 'Veri',
      expectation: 'Beklenti',
      before: 'Önceki',
      title: 'Başlık',
      more: 'Daha Fazla',
      close: 'Kapat',
      KurulusTarihi: 'Kuruluş Tarihi',
      SirketAdi: 'Şirket Adı',
      Sektor: 'Sektör',
      GenelMudur: 'Genel Müdür',
      CalisanSayisi: 'Çalışan Sayısı',
      listeholders: 'Ortaklar',
      listeholdings: 'İştirakler',
      YetkiliAd: 'Yatırımcı İlişkileri Yetkilisi',
      YetkiliMail: 'EPosta Adresi',
      Piyasa: 'Piyasa',
      Telefon: 'Telefon',
      Faks: 'Faks',
      Adres: 'Adres',
      rights_issue: 'Bedelli',
      gratis: 'Bedelsiz',
      dividend: 'Temettü',
      ratio: 'Oran',
      piece: 'Adet',
      KurumAdi: 'Aracı Kurum',
    }
  }
}

const i18n = new VueI18n({
  locale: 'tr', // set default locale
  messages,
})

new Vue({
  store,
  i18n,
  render: h => h(App)
}).$mount('#app')
